// import { eventBus } from "@/eventBus";
// import { store } from "@/store/store";

// export function observerInterSection() {
//     var observer = new IntersectionObserver(onIntersect);
//     document.querySelectorAll("[data-lazy-load]").forEach(function (img) {
//       observer.observe(img);
//     });
//     function onIntersect(entries, observer) {
//       entries.forEach(function (entry) {
//         if (entry.target.getAttribute("data-processed") || !entry.isIntersecting)
//           return true;
//         entry.target.setAttribute("src", entry.target.getAttribute("data-src"));
//         entry.target.setAttribute("data-processed", true);
//       });
//     }
// }

import { eventBus } from "@/eventBus";
import { store } from "@/store/store";

export function observerInterSection() {
  const observer = new IntersectionObserver(onIntersect, {
    root: null, // default viewport
    rootMargin: "0px",
    threshold: 0.1, // trigger when 10% of the image is visible
  });

  // Initial image observation
  observeLazyImages();

  // Re-run observation when needed (optional if new content is added dynamically)
  eventBus.$on("reobserve-images", observeLazyImages);

  function observeLazyImages() {
    document.querySelectorAll("[data-lazy-load]").forEach((img) => {
      if (!img.getAttribute("data-processed")) {
        observer?.observe(img);
      }
    });
  }

  function onIntersect(entries) {
    entries.forEach((entry) => {
      const img = entry.target;

      if (!entry.isIntersecting || img.getAttribute("data-processed")) return;

      const dataSrc = img.getAttribute("data-src");
      if (!dataSrc) return;

      img.setAttribute("src", dataSrc);
      img.setAttribute("data-processed", "true");
      observer?.unobserve(img); // Stop observing once processed
    });
  }
}
